import Component from '@glimmer/component';
import FormUnderlineLabel from 'donor-elf-web/components/form/underline/label';
import FormUnderlineSelect from 'donor-elf-web/components/form/underline/select';

interface ComponentArgs {
  changeset: any;
}

export default class AddSomethingModalMergeContactsAddNamesQuestionsComponent extends Component<ComponentArgs> {
  <template>
    <div>
      <p>
        Do you want to add the original contact's name as a note to the current
        tasks and pledges before merging the contacts?
        This will help you keep track of which tasks and pledges were associated
        with the original contact, even after the merge.
      </p>
      <p>
        This can be useful if the contact records being merged have different
        names, but it's not very helpful if the names are the same.
      </p>
      <div class='mt-4 tw-max-w-64'>
        <FormUnderlineLabel
          @label='Append Contact Name to Task Notes'
        >
          <FormUnderlineSelect
            @changeset={{@changeset}}
            @property='addNameToTasks'
            @booleanOptions={{true}}
            @dropdownContentClass='tw-z-1100'
            @dropdownMatchTriggerWidth={{true}}
            class='mb-3'
          />
        </FormUnderlineLabel>
        <FormUnderlineLabel
          @label='Append Contact Name to Pledge Notes'
        >
          <FormUnderlineSelect
            @changeset={{@changeset}}
            @property='addNameToPledges'
            @booleanOptions={{true}}
            @dropdownContentClass='tw-z-1100'
            @dropdownMatchTriggerWidth={{true}}
          />
        </FormUnderlineLabel>
      </div>
    </div>
  </template>
}
